import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { AccommodationDataViewModel } from 'src/app/receipt-long-op/view-models/accommodation-data.view-model';
import { ExpandableComponent, LabelledTextBoxComponent, MessageResourceManager, NTSTranslatePipe } from '@nts/std';
import { firstValueFrom, Observable } from 'rxjs';
import { NgIf } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { BaseStepComponent } from '../base-step.component';
import { WeaSettingsDataDto } from 'src/app/create-expense-annotation-long-op/api-clients/dto/wea-settings-data.dto';
import { ManageAccomodationData } from 'src/app/wea-settings/domain-models/manage-accomodation-data';

@UntilDestroy()
@Component({
  selector: 'nts-accommodation-data-step',
  templateUrl: './accommodation-data-step.component.html',
  styleUrls: ['./accommodation-data-step.component.scss'],
  standalone: true,
  imports: [
    NTSTranslatePipe,
    NgIf,
    SvgIconComponent,
    ExpandableComponent,
    LabelledTextBoxComponent
  ]
})
export class AccommodationDataStepComponent extends BaseStepComponent<AccommodationDataViewModel> {

  untilDestroyed(): <U>(source: Observable<U>) => Observable<U> {
    return untilDestroyed(this);
  }

  get currentConfiguration(): WeaSettingsDataDto {
    return this.rootViewModel?.params?.expenseData?.configuration;
  }

  get accomodationDataConfiguration(): ManageAccomodationData {
    return this?.currentConfiguration?.manageAccomodationData;
  }

  async onViewModelLoaded() {

    this.receiptStepsService.stepLoading.next(true);
    const viewModel = this.receiptStepsService.getCurrentState() as AccommodationDataViewModel;

    const queryParams = await firstValueFrom(this.routeStateService.queryParams);
    let expenseAnnotationId = null;
    if (queryParams['expenseAnnotationId']) {
      expenseAnnotationId = parseInt(queryParams['expenseAnnotationId'], 10);
    }
    const remoteExpense = queryParams['remoteExpense'] === 'true';

    viewModel.initPresentationLogic(
      expenseAnnotationId,
      remoteExpense,
      this.rootViewModel.params.expenseSelection.expenseClassification.value,
      this.rootViewModel.params.expenseState,
      !(await this.isReadOnly(this.rootViewModel))
    );

    this.receiptStepsService.orchestratorViewModel.rootViewModelModified.pipe(untilDestroyed(this)).subscribe(() => {
      viewModel.validateStep();
    });

    viewModel.validateStep();

    this.inIframe = this.activatedRoute.snapshot.queryParams['iframe'] === 'true' || window.self !== window.top;

    const params = await firstValueFrom(this.routeStateService.params);
    const currentAction = params.get('action');

    this.receiptStepsService.stepLoading.next(false);


    this.viewModel = viewModel;

    const customTitle = viewModel.newLabels().value[viewModel.currentExpenseClassificationType];
    const title = customTitle ?? MessageResourceManager.Current.getMessage('ExpenseClassification_' + viewModel.expenseClassificationEnum[viewModel.currentExpenseClassificationType]);
    this.telemetryService.trackPageView({ name: title });
  };

}

